/* Phone comparer (/pages/compare-phones). Specs from #ss-phones (snippets/phone-specs-data.liquid),
   live prices from /products/<handle>.js. URL state: ?p=h1,h2[,h3]. */
(function () {
  var root = document.querySelector('[data-phc]');
  var dataEl = document.getElementById('ss-phones');
  if (!root || !dataEl) return;
  var DATA = JSON.parse(dataEl.textContent);
  var BY = {};
  DATA.phones.forEach(function (p) { BY[p.h] = p; });
  var GRADES = ['Fair', 'Good', 'Excellent', 'Premium', 'New Sealed'];
  var DEFAULT = ['iphone-17', 'samsung-galaxy-s25', 'google-pixel-10']; // keep in sync with build.py
  var MAX = 3;
  var sel = [];
  var onlyDiff = false;
  var prices = {};
  var pending = {};

  var $ = function (s, el) { return (el || root).querySelector(s); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var num = function (s) { var m = String(s || '').replace(/,/g, '').match(/[\d.]+/); return m ? parseFloat(m[0]) : null; };
  var img = function (p, w) { return p.img ? p.img + (p.img.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; };
  var money = function (c) { return '$' + (c / 100).toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
  var shortName = function (n) { return n.replace(/^Samsung /, '').replace(/^Google /, ''); };

  /* ---------- state ---------- */
  function readUrl() {
    var q = new URLSearchParams(location.search).get('p');
    if (q === '') { sel = []; return; } // cleared on purpose
    var hs = (q ? q.split(',') : DEFAULT).filter(function (h, i, a) { return BY[h] && a.indexOf(h) === i; }).slice(0, MAX);
    if (!hs.length) hs = DEFAULT.slice(0, 3);
    sel = hs;
  }
  function writeUrl() {
    try {
      var u = new URL(location.href);
      u.searchParams.set('p', sel.join(',')); // empty p= means the shopper cleared everything
      history.replaceState(null, '', u.pathname + '?' + u.searchParams.toString().replace(/%2C/g, ','));
    } catch (e) {}
  }

  /* ---------- prices ---------- */
  function loadPrice(h) {
    if (prices[h] || pending[h]) return;
    pending[h] = true;
    fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      pending[h] = false;
      if (!j) { prices[h] = { none: true }; render(); return; }
      var ci = -1, si = -1;
      (j.options || []).forEach(function (o, i) {
        var n = (o.name || o).toString().toLowerCase();
        if (n === 'condition' || n === 'grade') ci = i;
        if (n === 'storage' || n === 'capacity') si = i;
      });
      var g = {}, best = null, storage = [];
      j.variants.forEach(function (v) {
        var opt = v.options || [v.option1, v.option2, v.option3];
        if (si > -1 && storage.indexOf(opt[si]) < 0) storage.push(opt[si]);
        if (!v.available) return;
        var c = ci > -1 ? opt[ci] : 'Price';
        if (!g[c] || v.price < g[c].price) g[c] = { price: v.price, id: v.id };
        if (!best || v.price < best.price) best = { price: v.price, id: v.id };
      });
      prices[h] = { grades: g, best: best, storage: storage, hasGrades: ci > -1 };
      render();
    }).catch(function () { pending[h] = false; prices[h] = { none: true }; render(); });
  }

  /* ---------- spec rows ---------- */
  function hz(p) { return p.hz ? p.hz + 'Hz' : ''; }
  var GROUPS = [
    ['Display', [
      ['Screen size', function (p) { return p.size ? p.size + '"' : ''; }],
      ['Cover screen', function (p) { return p.cover ? p.cover + '"' : ''; }],
      ['Screen type', function (p) { return p.disp; }],
      ['Resolution', function (p) { return p.res; }],
      ['Refresh rate', hz]
    ]],
    ['Performance', [
      ['Chip', function (p) { return p.chip; }],
      ['Network', function (p) { return p.g5 === 'Yes' ? '5G' : '4G LTE'; }],
      ['Apple Intelligence', function (p) { return p.brand === 'Apple' ? (p.ai || 'No') : ''; }]
    ]],
    ['Cameras', [
      ['Rear cameras', function (p) { return p.rear; }],
      ['Main camera', function (p) { return p.mmp; }],
      ['Optical zoom', function (p) { return p.tele ? p.tele + ' optical' : 'None'; }],
      ['Front camera', function (p) { return p.front; }]
    ]],
    ['Battery and charging', [
      ['Battery', function (p) { return p.bat; }],
      ['Connector', function (p) { return p.port; }],
      ['Wireless charging', function (p) { return p.ms ? (p.brand === 'Apple' && p.ms === 'Yes' ? 'Yes, MagSafe' : p.ms) : ''; }]
    ]],
    ['Design', [
      ['Weight', function (p) { return p.w; }],
      ['Water resistance', function (p) { return p.ip; }],
      ['Unlock', function (p) { return p.bio; }],
      ['S Pen', function (p) { return p.pen; }]
    ]],
    ['Software', [
      ['Operating system', function (p) { return p.os; }],
      ['Released', function (p) { return p.rel; }],
      ['Carrier', function () { return 'Unlocked'; }]
    ]]
  ];

  var METERS = [
    { k: 'Screen size', v: function (p) { return num(p.size); }, u: '"', tag: 'Biggest' },
    { k: 'Refresh rate', v: function (p) { return num(p.hz); }, u: 'Hz', tag: 'Smoothest' },
    { k: 'Main camera', v: function (p) { return num(p.mmp); }, u: 'MP', tag: 'Most MP' },
    { k: 'Optical zoom', v: function (p) { return p.tele ? num(p.tele) : 0; }, u: 'x', tag: 'Most zoom', skipZero: true },
    { k: 'Battery', v: function (p) { return num(p.bat); }, u: ' mAh', tag: 'Biggest', all: true },
    { k: 'Weight', v: function (p) { return num(p.w); }, u: ' g', tag: 'Lightest', low: true }
  ];

  /* ---------- render ---------- */
  function slotHtml(p, i) {
    if (!p) {
      return '<button type="button" class="phc-slot phc-slot--empty" data-phc-pick="' + i + '"><span class="phc-slot__plus" aria-hidden="true">+</span><span class="phc-slot__add">Add a phone</span></button>';
    }
    var pr = prices[p.h];
    var from = pr && pr.best ? '<span class="phc-slot__from">From <b>' + money(pr.best.price) + '</b></span>' : (pr && (pr.none || !pr.best) ? '<span class="phc-slot__from">Sold out</span>' : '<span class="phc-slot__from phc-skel">&nbsp;</span>');
    return '<div class="phc-slot" style="--c:var(--phc-c' + i + ')">' +
      '<button type="button" class="phc-slot__x" data-phc-rm="' + i + '" aria-label="Remove ' + esc(p.n) + '">×</button>' +
      '<a class="phc-slot__img" href="/products/' + p.h + '">' + (p.img ? '<img src="' + esc(img(p, 360)) + '" alt="' + esc(p.n) + '" width="180" height="180">' : '') + '</a>' +
      '<div class="phc-slot__meta"><b class="phc-slot__name">' + esc(p.n) + '</b><span class="phc-slot__rel">' + esc(p.rel || '') + '</span>' + from + '</div>' +
      '<button type="button" class="phc-slot__chg" data-phc-pick="' + i + '">Change</button>' +
      '</div>';
  }

  function renderSlots() {
    var html = '';
    for (var i = 0; i < MAX; i++) html += slotHtml(BY[sel[i]], i);
    $('[data-phc-slots]').innerHTML = html;
    $('[data-phc-slots]').style.setProperty('--n', MAX);
    $('[data-phc-bar]').innerHTML = '<div class="page-width phc-bar__in" style="--n:' + sel.length + '">' + sel.map(function (h, i) {
      var p = BY[h]; var pr = prices[h];
      return '<div class="phc-bar__p" style="--c:var(--phc-c' + i + ')">' + (p.img ? '<img src="' + esc(img(p, 80)) + '" alt="" width="32" height="32">' : '') + '<span><b>' + esc(shortName(p.n)) + '</b>' + (pr && pr.best ? '<em>From ' + money(pr.best.price) + '</em>' : '') + '</span></div>';
    }).join('') + '</div>';
  }

  function cols(inner) { return '<div class="phc-cols" style="--n:' + sel.length + '">' + (Array.isArray(inner) ? inner.join('') : inner) + '</div>'; }

  function priceBlock(ps) {
    return '<div class="phc-card"><h2 class="phc-h">Price by condition</h2><p class="phc-sub">Live from our store. Every grade is tested, reset and unlocked.</p>' +
      cols(ps.map(function (p, i) {
        var pr = prices[p.h];
        var body;
        if (!pr) body = '<div class="phc-skel phc-skel--box"></div>';
        else if (pr.none || !pr.best) body = '<p class="phc-out">Sold out in every condition right now.</p>';
        else {
          body = '<ul class="phc-grades">' + (pr.hasGrades ? GRADES : ['Price']).map(function (g) {
            var x = pr.grades[g];
            if (!x && g === 'Price') return '';
            return '<li class="' + (x ? '' : 'is-out') + '">' + (x ? '<a href="/products/' + p.h + '?variant=' + x.id + '">' : '<span>') +
              '<span class="phc-grades__g">' + esc(g === 'Price' ? 'From' : g) + '</span><span class="phc-grades__p">' + (x ? money(x.price) : 'Sold out') + '</span>' + (x ? '</a>' : '</span>') + '</li>';
          }).join('') + '</ul>' +
          (pr.storage.length ? '<p class="phc-stor">' + pr.storage.map(esc).join(' · ') + '</p>' : '');
        }
        return '<div class="phc-price" style="--c:var(--phc-c' + i + ')"><b class="phc-colname">' + esc(shortName(p.n)) + '</b>' + body +
          '<a class="phc-btn phc-btn--block" href="/products/' + p.h + (pr && pr.best ? '?variant=' + pr.best.id : '') + '">Shop ' + esc(shortName(p.n)) + '</a></div>';
      }).join('')) + '</div>';
  }

  function meters(ps) {
    var out = '';
    METERS.forEach(function (m) {
      var vals = ps.map(m.v);
      if (vals.every(function (v) { return v == null || v === 0; })) return;
      if (m.all && vals.some(function (v) { return v == null; })) return;
      if (m.skipZero && vals.every(function (v) { return !v; })) return;
      var known = vals.filter(function (v) { return v != null; });
      var max = Math.max.apply(null, known), min = Math.min.apply(null, known);
      var bestV = m.low ? min : max;
      var allSame = max === min;
      out += '<div class="phc-m"><span class="phc-m__k">' + m.k + '</span>' + cols(vals.map(function (v, i) {
        if (v == null) return '<div class="phc-m__c"><span class="phc-m__v">—</span></div>';
        var w = m.low ? (min / v) * 100 : (max ? (v / max) * 100 : 0);
        var isBest = !allSame && v === bestV;
        return '<div class="phc-m__c" style="--c:var(--phc-c' + i + ')"><span class="phc-m__v">' + (v === 0 && m.skipZero ? 'None' : v + m.u) +
          (isBest ? ' <em class="phc-tag">' + m.tag + '</em>' : '') + '</span><span class="phc-m__bar"><i style="width:' + Math.max(w, 4).toFixed(1) + '%"></i></span></div>';
      })) + '</div>';
    });
    return '<div class="phc-card"><h2 class="phc-h">At a glance</h2>' + out + '</div>';
  }

  function specs(ps) {
    var nd = 0;
    var html = GROUPS.map(function (g) {
      var rows = g[1].map(function (r) {
        var vals = ps.map(function (p) { return r[1](p) || ''; });
        if (vals.every(function (v) { return !v; })) return '';
        var diff = vals.some(function (v) { return v !== vals[0]; });
        if (diff) nd++;
        if (onlyDiff && !diff) return '';
        return '<div class="phc-row' + (diff ? ' is-diff' : '') + '"><span class="phc-row__k">' + r[0] + '</span>' +
          cols(vals.map(function (v, i) { return '<span class="phc-row__v" style="--c:var(--phc-c' + i + ')">' + (v ? esc(v) : '—') + '</span>'; })) + '</div>';
      }).join('');
      return rows ? '<div class="phc-grp"><h3>' + g[0] + '</h3>' + rows + '</div>' : '';
    }).join('');
    return '<div class="phc-card"><div class="phc-spechead"><h2 class="phc-h">Full specs</h2>' +
      '<label class="phc-toggle"><input type="checkbox" data-phc-diff' + (onlyDiff ? ' checked' : '') + '><span class="phc-toggle__ui" aria-hidden="true"></span>Only show differences</label></div>' +
      (ps.length > 1 ? '<p class="phc-sub">' + nd + ' spec' + (nd === 1 ? '' : 's') + ' differ. Highlighted rows are the ones that change between these phones.</p>' : '') + html + '</div>';
  }

  function fit(ps) {
    return '<div class="phc-card"><h2 class="phc-h">Who each one is for</h2>' + cols(ps.map(function (p, i) {
      return '<div class="phc-fit" style="--c:var(--phc-c' + i + ')"><b class="phc-colname">' + esc(shortName(p.n)) + '</b>' +
        (p.best ? '<p class="phc-fit__best">' + esc(p.best) + '</p>' : '') +
        (p.pros ? '<ul class="phc-pros">' + p.pros.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>' : '') +
        (p.cons ? '<ul class="phc-cons">' + p.cons.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>' : '') +
        '<a class="phc-link" href="/products/' + p.h + '">Full details and photos →</a></div>';
    })) + '</div>';
  }

  function articles(ps) {
    var hs = ps.map(function (p) { return p.h; });
    var found = Object.keys(DATA.articles).filter(function (a) {
      return DATA.articles[a].every(function (h) { return hs.indexOf(h) > -1; });
    });
    if (!found.length) return '';
    return found.map(function (a) {
      var pair = DATA.articles[a].map(function (h) { return shortName(BY[h].n); }).join(' vs ');
      return '<a class="phc-read" href="/blogs/journal/' + a + '"><span class="phc-read__k">In-depth</span><b>' + esc(pair) + ': our full comparison</b><span>Real-world differences, who should buy which, and what to skip →</span></a>';
    }).join('');
  }

  function render() {
    var ps = sel.map(function (h) { return BY[h]; });
    renderSlots();
    $('[data-phc-clear]').hidden = !sel.length;
    if (!sel.length) {
      $('[data-phc-body]').innerHTML = '<div class="phc-card phc-empty"><h2 class="phc-h">Pick phones to compare</h2><p class="phc-sub">Tap "Add a phone" above to start, or load one of the popular comparisons below.</p></div>';
      return;
    }
    var hint = sel.length === 1 ? '<p class="phc-note">Add a second phone above to see what\'s different.</p>' : '';
    $('[data-phc-body]').innerHTML = hint + articles(ps) + priceBlock(ps) + meters(ps) + specs(ps) + fit(ps);
  }

  function update() {
    writeUrl();
    sel.forEach(loadPrice);
    render();
  }

  /* ---------- picker ---------- */
  var dlg, pickIdx = 0, brand = 'All';
  var BRANDS = [['All', null], ['iPhone', 'iPhone'], ['Galaxy S', 'Galaxy S'], ['Galaxy Z', 'Galaxy Z'], ['Galaxy A', 'Galaxy A'], ['Galaxy Note', 'Galaxy Note'], ['Pixel', 'Pixel'], ['Motorola', 'Motorola']];
  function buildDialog() {
    dlg = document.createElement('dialog');
    dlg.className = 'phc-dlg';
    dlg.setAttribute('aria-label', 'Choose a phone');
    dlg.innerHTML = '<div class="phc-dlg__in"><div class="phc-dlg__top"><b>Choose a phone</b><button type="button" class="phc-dlg__x" data-close aria-label="Close">×</button></div>' +
      '<input type="search" class="phc-dlg__q" placeholder="Search, e.g. Pixel 9 or S24 Ultra" autocomplete="off" aria-label="Search phones">' +
      '<div class="phc-dlg__tabs" role="tablist">' + BRANDS.map(function (b) { return '<button type="button" role="tab" data-brand="' + b[0] + '">' + b[0] + '</button>'; }).join('') + '</div>' +
      '<ul class="phc-dlg__list"></ul></div>';
    document.body.appendChild(dlg);
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-close]')) return dlg.close();
      var b = e.target.closest('[data-brand]');
      if (b) { brand = b.getAttribute('data-brand'); list(); return; }
      var it = e.target.closest('[data-h]');
      if (it && !it.disabled) {
        sel[pickIdx] = it.getAttribute('data-h');
        sel = sel.filter(Boolean);
        dlg.close();
        update();
      }
    });
    dlg.querySelector('.phc-dlg__q').addEventListener('input', list);
  }
  function list() {
    var q = dlg.querySelector('.phc-dlg__q').value.trim().toLowerCase().replace(/\b(samsung|google)\b/g, '').replace(/\+/g, ' plus');
    var series = (BRANDS.filter(function (b) { return b[0] === brand; })[0] || [])[1];
    dlg.querySelectorAll('[data-brand]').forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-brand') === brand); });
    var words = q.split(/\s+/).filter(Boolean);
    var items = DATA.phones.filter(function (p) {
      if (series && p.s !== series) return false;
      var hay = (p.n + ' ' + p.h.replace(/-/g, ' ')).toLowerCase().replace(/\+/g, ' plus');
      return words.every(function (w) { return hay.indexOf(w) > -1; });
    });
    dlg.querySelector('.phc-dlg__list').innerHTML = items.length ? items.map(function (p) {
      var taken = sel.indexOf(p.h) > -1 && sel[pickIdx] !== p.h;
      return '<li><button type="button" data-h="' + p.h + '"' + (taken ? ' disabled' : '') + '>' +
        (p.img ? '<img src="' + esc(img(p, 96)) + '" alt="" width="40" height="40" loading="lazy">' : '<span class="phc-dlg__ph"></span>') +
        '<span><b>' + esc(p.n) + '</b><em>' + esc([p.rel, p.size ? p.size + '"' : '', p.chip].filter(Boolean).join(' · ')) + '</em></span>' +
        (taken ? '<i>Added</i>' : (sel[pickIdx] === p.h ? '<i>Current</i>' : '')) + '</button></li>';
    }).join('') : '<li class="phc-dlg__none">No phone matches that. Try a shorter search.</li>';
  }
  function openPicker(i) {
    if (!dlg) buildDialog();
    pickIdx = i;
    brand = 'All';
    dlg.querySelector('.phc-dlg__q').value = '';
    list();
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    if (window.matchMedia('(min-width: 750px)').matches) dlg.querySelector('.phc-dlg__q').focus();
  }

  /* ---------- events ---------- */
  root.addEventListener('click', function (e) {
    var pk = e.target.closest('[data-phc-pick]');
    if (pk) { openPicker(Math.min(+pk.getAttribute('data-phc-pick'), sel.length)); return; }
    if (e.target.closest('[data-phc-clear]')) { sel = []; update(); return; }
    var rm = e.target.closest('[data-phc-rm]');
    if (rm) { sel.splice(+rm.getAttribute('data-phc-rm'), 1); update(); return; }
    var ld = e.target.closest('[data-phc-load]');
    if (ld) {
      e.preventDefault();
      sel = ld.getAttribute('data-phc-load').split(',').filter(function (h) { return BY[h]; }).slice(0, MAX);
      update();
      $('.phc-tool').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
  root.addEventListener('change', function (e) {
    if (e.target.matches('[data-phc-diff]')) { onlyDiff = e.target.checked; render(); }
  });

  // Compact sticky bar once the phone cards scroll away
  if ('IntersectionObserver' in window) {
    var bar = $('[data-phc-bar]');
    var tool = $('.phc-tool');
    new IntersectionObserver(function (en) {
      var slotsGone = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      var r = tool.getBoundingClientRect();
      bar.hidden = !(slotsGone && r.bottom > 120 && sel.length);
    }, { threshold: 0 }).observe($('[data-phc-slots]'));
    window.addEventListener('scroll', function () {
      if (bar.hidden) return;
      if (tool.getBoundingClientRect().bottom < 120) bar.hidden = true;
    }, { passive: true });
  }

  readUrl();
  update();
})();
